import type { InputHTMLAttributes } from "react";

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  checked?: boolean;
  disabled?: boolean;
  label?: string;
}

export function Radio({ checked = false, disabled = false, label, onChange, style, ...rest }: RadioProps) {
  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        cursor: disabled ? "not-allowed" : "pointer",
        fontFamily: "var(--font-sans)",
        opacity: disabled && !checked ? 0.6 : 1,
        ...style,
      }}
    >
      <input
        type="radio"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}
        {...rest}
      />
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 22,
          height: 22,
          flex: "none",
          borderRadius: "var(--radius-full)",
          background: "var(--background-normal-normal)",
          boxShadow: checked
            ? `inset 0 0 0 6.5px ${disabled ? "var(--interaction-disable)" : "var(--primary-normal)"}`
            : `inset 0 0 0 1.5px ${disabled ? "var(--line-normal-alternative)" : "var(--line-normal-strong)"}`,
          transition: "box-shadow var(--duration-fast) var(--ease-standard)",
        }}
      />
      {label && (
        <span
          style={{
            fontSize: "var(--font-size-body-2)",
            lineHeight: "var(--line-height-body-2)",
            color: "var(--label-normal)",
          }}
        >
          {label}
        </span>
      )}
    </label>
  );
}

export default Radio;
